<template>
  <alzata-dialog
    ref="modal"
    size="xl"
    :title="veteran?.userId ? 'Edit Veteran' : 'Create Veteran'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <alzata-tabs toEdge ref="tabContainer">
          <alzata-tab title="Summary Info">
            <label for="firstname" class="small">First Name</label>
            <input
              id="firstName"
              type="text"
              class="form-control"
              placeholder="First Name"
              v-model="firstName"
            />
            <label for="lastName" class="small">Last Name</label>
            <input
              id="lastName"
              type="text"
              class="form-control"
              placeholder="Last Name"
              v-model="lastName"
            />
            <label for="email" class="small">Email / Username *</label>
            <input
              id="email"
              type="email"
              class="form-control"
              :class="{ 'is-invalid': errors.emailuser || errors.emailInUse }"
              placeholder="Email / Username"
              v-model="email"
            />
            <div v-if="errors.emailInUse" class="invalid-feedback">
              Email has already been registered.
            </div>
            <div v-if="errors.emailuser" class="invalid-feedback">
              Email/Username is required.
            </div>
            <label for="phone" class="small">Phone Number</label>
            <input
              id="phone"
              type="phone"
              class="form-control"
              placeholder="Phone Number"
              v-model="phoneNumber"
            />
            <div v-if="!veteran?.userId">
              <label for="password" class="small">Password *</label>
              <input
                id="password"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.password }"
                placeholder="Password"
                v-model="password"
              />
              <div v-if="errors.password" class="invalid-feedback">
                Password is required to be at least 6 characters, have at least one non alphanumeric character, have at least one upper case character, and have at least one lower case character.
              </div>
            </div>
          </alzata-tab>
          <alzata-tab title="Tasks">
            <TaskItemsList :veteranId="veteranId" />
          </alzata-tab>
        </alzata-tabs>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="hideEditVeteran">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="save">Save</button>
    </template>
  </alzata-dialog>
</template>

<script>

import TaskItemsList from "@/pages/TaskItemsList.vue";
import { doGet } from "../apis/baseApiClient";

export default {
  name: "EditVeteranDialog",
  components: {
    TaskItemsList,
  },
  emits: ["save"],
  data() {
    return {
      veteran: null,
      veteranId: null,
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      password: null,
      pushToken: null,
      dogId: null,
      errors: {
        emailuser: false,
        password: false,
        emailInUse: false,
      },
    };
  },
  methods: {
    clearValidation() {
      this.errors.emailuser = false;
      this.errors.password = false;
    },
    show(veteran) {
      
      this.$refs.tabContainer.reset();

      this.veteran = veteran;
      this.veteranId = veteran.id;
      this.firstName = veteran.firstName;
      this.lastName = veteran.lastName;
      this.email = veteran.email;
      this.phoneNumber = veteran.phoneNumber;
      this.password = null;
      this.pushToken = veteran.pushToken;
      this.dogId = veteran.dogId;
      
      this.clearValidation();

      this.$refs.modal.show();
    },
    hideEditVeteran() {
      this.clearValidation();
      this.$refs.modal.hide();
    },
    async save() {
      this.errors.emailInUse = "true" == await (await doGet("/api/v1/profiles/user-exists/" + encodeURIComponent(this.email))).text();
      const needsPassword = !this.veteranId;
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{6,}$/;

      if(needsPassword){
        this.errors.password = !this.password || !passwordRegex.test(this.password);
      }

      this.errors.emailuser = !this.email;

      if (this.errors.password || this.errors.emailuser || this.errors.emailInUse) {
        return;
      }

      this.$emit("save", {
        userId: this.veteran.userId,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phoneNumber: this.phoneNumber,
        password: this.password,
        pushToken: this.pushToken,
        dogId: this.dogId,
      });
    },
  },
};
</script>
